import {getUser} from "../@api/User";
import {setUserState} from "../store/reducers/user";
import {Dispatch} from "react";
import {AnyAction} from "redux";
import {getUserDomain} from "./GetUserDomain";

export const setUser = (dispatch: Dispatch<AnyAction>) => {
    getUser(getUserDomain())
        .then((response) => {
            dispatch(setUserState({user: response.data}))
            document.documentElement.classList.add(response.data.color);
        })
        .catch((e: Error) => {
            console.log(e);
            dispatch(setUserState({user: null}))
        });
};
